import { Outlet } from 'react-router-dom';
import BottomAppBar from 'layout/WarehouseLayout/BottomAppBar';
import TopAppBar from 'layout/WarehouseLayout/TopAppBar';
import { useEffect } from 'react';
import { PylonAction } from 'constants/pylonConstants';

// ==============================|| MOBILE INVENTORY LAYOUT ||============================== //

const WarehouseLayout = () => {
  useEffect(() => {
    window.Pylon(PylonAction.hideChatBubble);
    window.Pylon(PylonAction.onHide, () => {
      window.Pylon(PylonAction.hideChatBubble);
    });
  }, []);

  return (
    <>
      <TopAppBar />
      <Outlet />
      <BottomAppBar />
    </>
  );
};

export default WarehouseLayout;
